import styles from './main.module.scss';

export const Main = ({ children }: { children: React.ReactNode }) => {
  return (
    <main className={styles.main} id="main">
      {children}
    </main>
  );
};
